<div class="container-dev">
  <app-navbar></app-navbar>

  <app-developers-overlay-section (becomeMerchantClick)="openAgentModal()"></app-developers-overlay-section>

  <!-- Developer section -->
  <div class="developer">
    <div class="dev-left" data-aos="fade-up-right" data-aos-duration="2000">
      <div class="dev-title">
        <h2>Create well-documented APIs with great payment experiences</h2>
      </div>
      <div class="dev-text">
        <h3>
          Developers get to love our well-documented APIs that let you create everything from simple projects to
          complex financial products for all customers. If you can think or visualize it, you can create or build it
          with HuiosPay.
        </h3>
      </div>
      <div class="dev-bulletin">
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Collect one-time and recurring payments from your website or app.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Make quick transfers.</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Verify customer identities.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Fast & easy integrations.</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Effective customer support & service.</p>
            </div>
          </div>
        </div>
        <!-- <div class="list">
          <div class="list1">
            <div class="text">
              <p style="cursor: pointer;"><span style="color:#045A7D; padding-right: 10px;">HuiosPay API Quickstart
                </span>
                <img src="../../../../assets/img/arrow.png" alt="icon">
              </p>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div class="dev-right" data-aos="fade-up-left" data-aos-duration="2000">
      <img src="../../../../assets/img/coder.png" alt="terminal-lock">
    </div>
  </div>
  <!-- end of why huiospay-->


  <!-- Seamless Section -->
  <div class="seamless" id="seamless">
    <div class="seamless-left" data-aos="fade-up-left" data-aos-duration="2000">
      <img src="../../../../assets/img/paying.png" alt="terminal-lock">
    </div>

    <div class="seamless-right" data-aos="fade-up-right" data-aos-duration="2000">
      <div class="seamless-title">
        <h2>Seamless payment experience for our customers</h2>
      </div>
      <div class="seamless-text">
        <h3>
          Our goal is to expose our customers to possibilities of modern, frictionless and painless payments. Our
          ongoing commitment to efficiency manifests in our ability to provide a wide variety of payment options for
          your business needs.
        </h3>
      </div>
      <div class="seamless-bulletin">
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Debit/Credit Cards.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>POS.</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Mobile Money.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>USSD.</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Bank Transfer.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Visa QR.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Seamless Section-->

  <!-- Payment on all Platform section -->
  <div class="developer" id="documentation">
    <div class="dev-left" data-aos="fade-up-right" data-aos-duration="2000">
      <div class="dev-title">
        <h2>Accept payments on all shopping platforms</h2>
      </div>
      <div class="dev-text">
        <h3>
          HuiosPay's automated and manual anti-fraud systems protect you from fraudulent activities and associated
          chargeback claims.
        </h3>
      </div>
    </div>
    <div class="dev-right" data-aos="fade-up-left" data-aos-duration="2000">
      <img src="../../../../assets/img/tools.png" alt="terminal-lock">
    </div>
  </div>
  <!-- end Payment on all Platform section-->

  <!-- verify customer Section -->
  <div class="seamless">
    <div class="seamless-left" data-aos="fade-up-left" data-aos-duration="2000">
      <img src="../../../../assets/img/selfie.png" alt="terminal-lock">
    </div>
    <div class="seamless-right" data-aos="fade-up-right" data-aos-duration="2000">
      <div class="seamless-title">
        <h2>Verify your customer's
          identity</h2>
      </div>
      <div class="seamless-text">
        <h3>
          Need to verify that your customers are who they say they are? Our verification APIs allow you to do this in
          various ways possible.
        </h3>
      </div>
      <div class="gen-bulletin">
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Verify customer identity with a bank account number.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Verify customer identity with a phone number.</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Verify customer identity with a BVN.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End of verify Section-->

  <!-- Understand customer section -->
  <div class="developer">
    <div class="dev-left" data-aos="fade-up-right" data-aos-duration="2000">
      <div class="dev-title">
        <h2>Understand customer
          purchase methods &
          patterns</h2>
      </div>
      <div class="dev-text">
        <h3>
          Your HuiosPay dashboard surfaces useful customer insights from your payment data.
        </h3>
      </div>
      <div class="dev-bulletin">
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>See who your top customers are.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Check out your new and returning customers. </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dev-right" data-aos="fade-up-left" data-aos-duration="2000">
      <img src="../../../../assets/img/work.png" alt="terminal-lock">
    </div>
  </div>
  <!-- end of Understand customer-->

  <!-- Monitor your business-->
  <div class="our-solution" >
    <div class="our-left" data-aos="fade-up-right" data-aos-duration="2000">
      <img src="../../../../assets/img/black.png" alt="terminal">
    </div>
    <div class="our-right" data-aos="fade-up-left" data-aos-duration="2000">
      <div class="our-title">
        <h2>
          Monitor your business
          performance on the go
        </h2>
      </div>
      <div class="our-text">
        <h3>
          Sign up to HuiosPay and track your most important business metrics on any of your mobile devices. Monitor information such as customer information, sales, success rates, etc.
        </h3>
      </div>
      <div class="gen-bulletin">
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Sign up to HuiosPay in minutes.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Get invoices from your phone's comfort.</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Easily lookup any transactions.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Get notified on important updates.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Monitor your business-->

  <!-- Community section-->
  <app-community-section></app-community-section>
  <!--End Community section-->

  <!-- footer -->
  <app-footer></app-footer>
  <!-- end of footer -->

</div>

<app-back-to-top [acceleration]="2" [animate]="true" [scrollDistance]="50" [speed]="50">
</app-back-to-top>

<!-- POS Merchant Modal -->
<div class="agent-modal-overlay" *ngIf="showAgentModal" (click)="closeAgentModal()">
  <div class="agent-modal" (click)="$event.stopPropagation()">

    <!-- Step 1 -->
    <div *ngIf="currentStep === 1">
      <div class="modal-header">
        <h3 class="modal-title">New Merchant</h3>
        <div class="modal-title-accent-row">
          <div class="modal-progress-track">
            <div class="modal-progress-fill" [style.width]="(currentStep / 3 * 100) + '%'"></div>
          </div>
          <span class="modal-step-counter"><span class="step-current">01</span><span class="step-total">/03</span></span>
        </div>
        <hr class="modal-divider" />
        <p class="modal-subtitle"><span class="subtitle-dot">•</span> Kindly fill in your personal information to create a new merchant</p>
      </div>
      <div class="modal-body">
        <form [formGroup]="step1Form">
          <div class="form-row">
            <div class="form-group title-field">
              <label>Title <span class="req">*</span></label>
              <input type="text" formControlName="title" placeholder="e.g. Mr" />
              <small class="field-error" *ngIf="step1Form.get('title').invalid && step1Form.get('title').touched">Required</small>
            </div>
            <div class="form-group full-name-field">
              <label>Full Name <span class="req">*</span></label>
              <input type="text" formControlName="fullName" placeholder="Enter full name" />
              <small class="field-error" *ngIf="step1Form.get('fullName').invalid && step1Form.get('fullName').touched">Full name is required</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Marital Status <span class="req">*</span></label>
              <select formControlName="maritalStatus">
                <option value="">Select status</option>
                <option value="single">Single</option>
                <option value="married">Married</option>
                <option value="divorced">Divorced</option>
                <option value="widowed">Widowed</option>
              </select>
              <small class="field-error" *ngIf="step1Form.get('maritalStatus').invalid && step1Form.get('maritalStatus').touched">Marital status is required</small>
            </div>
            <div class="form-group">
              <label>Date of Birth <span class="req">*</span></label>
              <input type="date" formControlName="dateOfBirth" />
              <small class="field-error" *ngIf="step1Form.get('dateOfBirth').invalid && step1Form.get('dateOfBirth').touched">Date of birth is required</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>State of Origin <span class="req">*</span></label>
              <select formControlName="stateOfOrigin">
                <option value="">Select state</option>
                <option *ngFor="let state of nigerianStates" [value]="state">{{ state }}</option>
              </select>
              <small class="field-error" *ngIf="step1Form.get('stateOfOrigin').invalid && step1Form.get('stateOfOrigin').touched">State of origin is required</small>
            </div>
            <div class="form-group">
              <label>L.G.A. <span class="req">*</span></label>
              <input type="text" formControlName="lga" placeholder="Enter local government area" />
              <small class="field-error" *ngIf="step1Form.get('lga').invalid && step1Form.get('lga').touched">LGA is required</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group full-width">
              <label>Address <span class="req">*</span></label>
              <input type="text" formControlName="address" placeholder="Enter residential address" />
              <small class="field-error" *ngIf="step1Form.get('address').invalid && step1Form.get('address').touched">Address is required</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Email Address <span class="req">*</span></label>
              <input type="email" formControlName="email" placeholder="example@mail.com" />
              <small class="field-error" *ngIf="step1Form.get('email').invalid && step1Form.get('email').touched">Valid email is required</small>
            </div>
            <div class="form-group">
              <label>Phone Number <span class="req">*</span></label>
              <input type="tel" formControlName="phone" placeholder="0801 000 0000" />
              <small class="field-error" *ngIf="step1Form.get('phone').invalid && step1Form.get('phone').touched">Phone number is required</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group full-width">
              <label>Employment Status <span class="req">*</span></label>
              <select formControlName="employmentStatus">
                <option value="">Select status</option>
                <option value="employed">Employed</option>
                <option value="self-employed">Self Employed</option>
                <option value="unemployed">Unemployed</option>
                <option value="retired">Retired</option>
                <option value="student">Student</option>
              </select>
              <small class="field-error" *ngIf="step1Form.get('employmentStatus').invalid && step1Form.get('employmentStatus').touched">Employment status is required</small>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button class="btn-modal-cancel" type="button" (click)="closeAgentModal()">Cancel</button>
        <button class="btn-modal-next" type="button" (click)="nextStep()" [disabled]="step1Form.invalid">Next</button>
      </div>
    </div>

    <!-- Step 2 -->
    <div *ngIf="currentStep === 2">
      <div class="modal-header">
        <h3 class="modal-title">New Merchant</h3>
        <div class="modal-title-accent-row">
          <div class="modal-progress-track">
            <div class="modal-progress-fill" [style.width]="(currentStep / 3 * 100) + '%'"></div>
          </div>
          <span class="modal-step-counter"><span class="step-current">02</span><span class="step-total">/03</span></span>
        </div>
        <hr class="modal-divider" />
        <p class="modal-subtitle"><span class="subtitle-dot">•</span> Kindly fill in your Means of Identification to create a new merchant</p>
      </div>
      <div class="modal-body">
        <form [formGroup]="step2Form">
          <div class="form-row">
            <div class="form-group full-width">
              <label>BVN</label>
              <input type="text" formControlName="bvn" placeholder="e.g. 11-digit number" maxlength="11" />
              <small class="field-error" *ngIf="step2Form.get('bvn').invalid && step2Form.get('bvn').touched">BVN must be exactly 11 digits</small>
            </div>
          </div>
          <hr class="form-section-divider" />
          <p class="form-section-title">Identification Information</p>
          <div class="form-row">
            <div class="form-group full-width">
              <label>Means of Identification <span class="req">*</span></label>
              <select formControlName="meansOfId">
                <option value="">Choose Means of Identification</option>
                <option value="nin">National Identity Card (NIN)</option>
                <option value="passport">International Passport</option>
                <option value="drivers_license">Driver's License</option>
                <option value="voters_card">Voter's Card</option>
              </select>
              <small class="field-error" *ngIf="step2Form.get('meansOfId').invalid && step2Form.get('meansOfId').touched">Please select a means of identification</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group full-width">
              <label>Upload Identification Document <span class="req">*</span></label>
              <input type="file" hidden #idDocInput (change)="onIdDocumentChange($event)" accept=".jpg,.jpeg,.png,.pdf" />
              <div class="file-upload-field" [class.has-file]="idDocumentName" [class.error]="step2Form.get('idDocument').invalid && step2Form.get('idDocument').touched" (click)="idDocInput.click()">
                <span class="file-name">{{ idDocumentName || 'Choose files' }}</span>
                <svg class="file-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/></svg>
              </div>
              <small class="field-error" *ngIf="step2Form.get('idDocument').invalid && step2Form.get('idDocument').touched">Please upload your identification document</small>
            </div>
          </div>
          <hr class="form-section-divider" />
          <p class="form-section-title">Proof of Address Information</p>
          <div class="form-row">
            <div class="form-group full-width">
              <label>Means of Verification <span class="req">*</span></label>
              <select formControlName="meansOfVerification">
                <option value="">Choose means of verification</option>
                <option value="utility_bill">Utility Bill</option>
                <option value="bank_statement">Bank Statement</option>
                <option value="tenancy_agreement">Tenancy Agreement</option>
                <option value="government_letter">Government Letter</option>
              </select>
              <small class="field-error" *ngIf="step2Form.get('meansOfVerification').invalid && step2Form.get('meansOfVerification').touched">Please select a means of verification</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group full-width">
              <label>Upload Proof of Address <span class="req">*</span></label>
              <input type="file" hidden #proofInput (change)="onProofOfAddressChange($event)" accept=".jpg,.jpeg,.png,.pdf" />
              <div class="file-upload-field" [class.has-file]="proofOfAddressName" [class.error]="step2Form.get('proofOfAddress').invalid && step2Form.get('proofOfAddress').touched" (click)="proofInput.click()">
                <span class="file-name">{{ proofOfAddressName || 'Choose files' }}</span>
                <svg class="file-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 0 1 5 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 0 0 5 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/></svg>
              </div>
              <small class="field-error" *ngIf="step2Form.get('proofOfAddress').invalid && step2Form.get('proofOfAddress').touched">Please upload proof of address</small>
            </div>
          </div>
          <p class="form-note">*All documents should be valid at the time of registration</p>
        </form>
      </div>
      <div class="modal-footer">
        <button class="btn-modal-cancel" type="button" (click)="currentStep = 1">Back</button>
        <button class="btn-modal-next" type="button" (click)="nextStep()" [disabled]="step2Form.invalid">Next</button>
      </div>
    </div>

    <!-- Step 3 -->
    <div *ngIf="currentStep === 3">
      <div class="modal-header">
        <h3 class="modal-title">New Merchant</h3>
        <div class="modal-title-accent-row">
          <div class="modal-progress-track">
            <div class="modal-progress-fill" [style.width]="(currentStep / 3 * 100) + '%'"></div>
          </div>
          <span class="modal-step-counter"><span class="step-current">03</span><span class="step-total">/03</span></span>
        </div>
        <hr class="modal-divider" />
        <p class="modal-subtitle"><span class="subtitle-dot">•</span> Kindly fill in your Next of Kin information to create a new merchant</p>
      </div>
      <div class="modal-body">
        <form [formGroup]="step3Form">
          <div *ngIf="submissionAlert" class="submission-alert" [class.is-success]="submissionAlert.type === 'success'" [class.is-error]="submissionAlert.type === 'error'">
            <p class="alert-message">{{ submissionAlert.message }}</p>
            <ul *ngIf="submissionAlert.errors.length > 0" class="alert-errors">
              <li *ngFor="let err of submissionAlert.errors">{{ err }}</li>
            </ul>
          </div>
          <div class="form-row">
            <div class="form-group title-field">
              <label>Title <span class="req">*</span></label>
              <input type="text" formControlName="kinTitle" placeholder="e.g. Mr" />
              <small class="field-error" *ngIf="step3Form.get('kinTitle').invalid && step3Form.get('kinTitle').touched">Required</small>
            </div>
            <div class="form-group full-name-field">
              <label>Full Name <span class="req">*</span></label>
              <input type="text" formControlName="kinFullName" placeholder="Enter full name" />
              <small class="field-error" *ngIf="step3Form.get('kinFullName').invalid && step3Form.get('kinFullName').touched">Full name is required</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Date of Birth <span class="req">*</span></label>
              <input type="date" formControlName="kinDateOfBirth" />
              <small class="field-error" *ngIf="step3Form.get('kinDateOfBirth').invalid && step3Form.get('kinDateOfBirth').touched">Date of birth is required</small>
            </div>
            <div class="form-group">
              <label>Relationship <span class="req">*</span></label>
              <select formControlName="kinRelationship">
                <option value="">Choose status</option>
                <option value="father">Father</option>
                <option value="mother">Mother</option>
                <option value="sibling">Sibling</option>
                <option value="spouse">Spouse</option>
                <option value="child">Child</option>
                <option value="friend">Friend</option>
                <option value="other">Other</option>
              </select>
              <small class="field-error" *ngIf="step3Form.get('kinRelationship').invalid && step3Form.get('kinRelationship').touched">Relationship is required</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>State of Origin <span class="req">*</span></label>
              <select formControlName="kinStateOfOrigin">
                <option value="">Choose state</option>
                <option *ngFor="let state of nigerianStates" [value]="state">{{ state }}</option>
              </select>
              <small class="field-error" *ngIf="step3Form.get('kinStateOfOrigin').invalid && step3Form.get('kinStateOfOrigin').touched">State of origin is required</small>
            </div>
            <div class="form-group">
              <label>L.G.A. <span class="req">*</span></label>
              <input type="text" formControlName="kinLga" placeholder="e.g. AMAC Municipal" />
              <small class="field-error" *ngIf="step3Form.get('kinLga').invalid && step3Form.get('kinLga').touched">LGA is required</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group full-width">
              <label>Address <span class="req">*</span></label>
              <input type="text" formControlName="kinAddress" placeholder="e.g. No., Street, City" />
              <small class="field-error" *ngIf="step3Form.get('kinAddress').invalid && step3Form.get('kinAddress').touched">Address is required</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Phone Number <span class="req">*</span></label>
              <input type="tel" formControlName="kinPhone" placeholder="e.g. +234-000-0000-000" />
              <small class="field-error" *ngIf="step3Form.get('kinPhone').invalid && step3Form.get('kinPhone').touched">Phone number is required</small>
            </div>
            <div class="form-group">
              <label>Email Address</label>
              <input type="email" formControlName="kinEmail" placeholder="e.g. name@domain.com" />
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button class="btn-modal-cancel" type="button" (click)="currentStep = 2">Back</button>
        <button class="btn-modal-next" type="button" (click)="completeRegistration()" [disabled]="step3Form.invalid || isSubmitting">
          {{ isSubmitting ? 'Submitting...' : 'Complete Registration' }}
        </button>
      </div>
    </div>

  </div>
</div>